/**
 * Sorting for the personal timesheet (time-2).
 *
 * Two traps live here, which is why it is its own module rather than a lambda
 * in the page:
 *
 *  1. `Table` derives its sort key from the DISPLAYED column label
 *     (`label.toLowerCase().replace(/\s+/g, '_')`), and those labels are
 *     translated — so a comparator keyed off the English name silently stops
 *     matching the moment the app is in Bulgarian.
 *  2. `hours_decimal` arrives as a decimal STRING. Compared as text, 9.5 sorts
 *     after 10, which on a timesheet reads as the data being wrong.
 */

/** The key `Table` will hand back to `onSort` for a given column label. */
export const sortKeyOf = (label: string) => label.toLowerCase().replace(/\s+/g, '_');

/**
 * Sort a copy of `rows` by the value each one yields. Numbers compare
 * numerically, everything else through `localeCompare` so accented and
 * Cyrillic names order the way the reader expects.
 */
export function sortRowsBy<T>(
  rows: T[],
  value: (row: T) => string | number,
  order: 'asc' | 'desc',
): T[] {
  const dir = order === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const av = value(a);
    const bv = value(b);
    if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * dir;
    return String(av).localeCompare(String(bv)) * dir;
  });
}
